// @flow

import styled, { css } from 'styled-components';
import { Box } from '../../../grid';
import media from '../../../../helpers/media';
import type { Theme } from '../../../../types';

const CartSummaryComponent = styled<typeof Box, Theme, _>(Box)`
  margin-left: .5rem;

  ${media.md(css`
    margin-left: 1.75rem;
  `)};

  &:first-child {
    margin-left: 0;
  }
`;

const CartHamburgerComponent = styled<typeof CartSummaryComponent, Theme, _>(CartSummaryComponent)`
  ${media.lg(css`
    display: none;
  `)}
`;

const CartSummaryContainer = styled<typeof Box, Theme, _>(Box)`
  padding: 0.85rem 0;
  flex-grow: 1;

  ${media.md(css`
    flex-grow: 0;
  `)}
`;

export {
  CartHamburgerComponent,
  CartSummaryComponent,
  CartSummaryContainer,
};

export default null;
